module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Matteo-jongen-koperfolie-foliedruk-digitaal-drukwerk-2.9afa5a69.jpg";